import { Box, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateFields } from "../../../redux/profileSlice";

const V2MentorDetails = ({ localProfile }) => {
  const profile = localProfile?.profile ?? {};
  const updatedFields = useSelector(
    (state) => state.profileSlice?.updatedFields,
  );
  const dispatch = useDispatch();
  const mentorProfile = profile.mentorProfile ?? {};
  const updatedMentorProfile = updatedFields?.mentorProfile ?? {};

  const valueFor = (field) =>
    updatedMentorProfile[field] ?? mentorProfile[field] ?? "";
  const update = (field, value) => {
    if (value.trim().split(/\s+/).filter(Boolean).length <= 500) {
      dispatch(updateFields({ field: `mentorProfile.${field}`, value }));
    }
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography sx={{ fontWeight: 600, mb: 1 }}>Mentor details</Typography>
      {[
        ["Guiding Approach", "guidingOthersQualityToBeMentor"],
        ["Inspiration Story", "inspirationStory"],
      ].map(([label, field]) => {
        const value = valueFor(field);
        return (
          <Box key={field} sx={{ mb: 2 }}>
            <Typography sx={{ mb: 0.5 }}>{label}</Typography>
            <TextField
              multiline
              minRows={4}
              fullWidth
              value={value}
              placeholder="Enter here..."
              onChange={(event) => update(field, event.target.value)}
              inputProps={{ "aria-label": label }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "#F4F9FE",
                },
              }}
            />
            <Typography
              variant="body2"
              sx={{ textAlign: "right", mt: 0.5, color: "#7A7A7A" }}
            >
              {`${value.trim().split(/\s+/).filter(Boolean).length}/500`}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default V2MentorDetails;
